import { useCardConfigs } from '@web-platform/shared-travel-tools-data-access-frontend';
import { useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';

import { buildAppCardProps } from '../utils/cards';

import type { AppCardProps } from '../utils/cards';

export const useAppCardProps = (): AppCardProps[] => {
  const { translate } = useTranslations();
  const cardConfigs = useCardConfigs();

  return buildAppCardProps(translate, cardConfigs);
};
